<template>
    <div class="type_check_box" v-loading="loading">
        <el-dialog title="评论" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="form_box">
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            服务评分
                        </div>
                        <div class="form_inputs">
                            <div class="num_flex">
                                <div class="item_img" v-for="(item,index) in 5" :key="index" @click="num_index=(index+1)">
                                    <img src="@/assets/img/index/legal/plx_ac.png" alt="" v-if="index<=(num_index-1)">
                                    <img src="@/assets/img/index/legal/plx_ac_no.png" alt="" v-if="index>(num_index-1)">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            服务评价
                        </div>
                        <div class="form_inputs">
                            <div class="textarea_box">
                                <el-input type="textarea" v-model="form.desc" placeholder="请输入服务评价"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
            
              
                <div class="btn_flex">
                    <div class="bnts1" @click="handle_end">确定</div>
                    <div class="bnts2" @click="handleClose">取消</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
            num_index:0,
            form:{
                desc:'',
            }
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        handle_open(){
            this.dialogVisible=true
        },
        handle_end(){
            if(!this.form.desc){
                alertErr('请输入服务评价')
                return
            }
            this.$api("caseComment", {
                id:this.$route.query.id,
                comment_id:0,
                level:this.num_index,
                content:this.form.desc
			}, "post").then((res) => {
                this.loading = false
                console.log('案例评论提交',res)
                if (res.code == 1) {
                    this.$emit('pl_end')
                } else {
                    alertErr(res.msg)
                }
            });
            this.dialogVisible=false
           
        },
       
      

    },

}
</script>
<style scoped lang="less">
.type_check_box {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 1050px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    .form_box{
                        .form_flex{
                            display: flex;
                            align-items: center;
                            margin-bottom: 26px;
                            .form_title{
                                width: 200px;
                                text-align: right;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                flex-shrink: 0;
                                span{
                                    color: #FD4C5C;
                                }
                            }
                            .form_inputs{
                                padding-left: 21px;
                                flex: 1;
                                .num_flex{
                                    display: flex;
                                    align-items: center;
                                    .item_img{
                                        cursor: pointer;
                                        img{
                                            width: 21px;
                                            height: 20px;
                                        }
                                    }
                                }
                                .textarea_box{
                                    width: 100%;
                                }
                            }

                        }
                    }
                  
                     
                    
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;

                        
                        .bnts1{
                            width: 104px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left:20px ;
                        }
                        .bnts2{
                            width: 104px;
                            height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            margin-left: 20px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
}
</style>